import fetch from '../core/fetch';
import { parseResponse } from '../core/fetch/response';

export default class Pages {
  static getPagesURLForSlug(slug, application = 'play') {
    return `${process.env.REACT_APP_CLIENT_PAGES_API}/${slug}?fender-application=${application}`;
  }

  static async getPagesBySlug(slug, application = 'play') {
    const response = await fetch(Pages.getPagesURLForSlug(slug, application));
    return parseResponse(response);
  }
}
